//TODO: this should be in sync with electron version

import apm, { type ApmBase } from '@elastic/apm-rum'
import { type TelemetryConfig, type TelemetryMetadata, type TelemetryTransaction } from '@/features/telemetry/types'

export function useAPMTelemetryAdapter(configOptionGetter: <T extends keyof TelemetryConfig>(key: T) => TelemetryConfig[T] | undefined) {
	let apmClient: ApmBase | undefined = undefined

	const apmConfig = configOptionGetter('ELASTIC_APM')

	if (apmConfig) {
		apmClient = apm(apmConfig)
	} else {
		console.warn('Missing Elastic url or APM url - Elastic APM telemetry not initialized.')
	}

	return {
		trackEvent() {
			// Not used in APM adapter
		},

		trackException() {
			// Not used in APM adapter
		},

		trackPageView() {
			// Not tracked in Elastic adapter
		},

		setMetadata(metadata: TelemetryMetadata) {
			apmClient?.setUserContext({ email: metadata.user?.username, id: metadata.user?.id })
		},

		startTransaction(name: string, type: string) {
			return apmClient?.startTransaction(name, type) as TelemetryTransaction
		}
	}
}
